import { observer } from "mobx-react";
import React, { useEffect, useState } from "react";
import * as Utils from "../utils/Utils";
import * as mod_i18n from "../utils/i18n";
export const RightMenu = observer((props) => {
    const [menuRight, setMenuRight] = useState([]);
    const pathToStatic = props.appModel.pathToStatic;
    const pathToApi = props.appModel.pathToAppFrameApi;
    const i18n = props.appModel.i18n.bind(props.appModel);
    const lang = props.appModel.language;
    const defaultLang = props.appModel.config.defaultLanguage;
    useEffect(() => {
        Utils.fetchAsync(pathToApi + "menu/right", null, (value) => {
            const newValue = value && value["children"];
            if (newValue == null) {
                setMenuRight([]);
            }
            else {
                setMenuRight(newValue);
            }
        });
    }, []);
    const getMenuTitle = (menuEntry) => {
        return mod_i18n.getMenuTitle(menuEntry, lang, defaultLang);
    };
    const getMenuUrl = (menuEntry) => {
        return mod_i18n.getMenuUrl(menuEntry, lang, defaultLang);
    };
    const closeMenuRight = () => {
        props.appModel.appState.setRightMenuOpen(false);
    };
    const renderRightMenuItems = () => {
        try {
            return (React.createElement(React.Fragment, null,
                React.createElement("ul", { className: "clearfix navbar-nav__item" }, menuRight.map((menuItem, i) => (React.createElement("li", { className: "nav-item", key: i },
                    React.createElement("a", { href: getMenuUrl(menuItem), className: "nav-link", key: i }, getMenuTitle(menuItem))))))));
        }
        catch (ex) {
            console.error(ex);
            return (React.createElement(React.Fragment, null,
                React.createElement("ul", { className: "clearfix navbar-nav__item" })));
        }
    };
    let isOpen = props.appModel.appState.rightMenuOpen;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "menu-right" },
            React.createElement("div", { className: "menu-right--menu" + (isOpen == true ? " isOpened" : "") },
                React.createElement("div", { className: "menu-right__inner" },
                    React.createElement("div", { className: "menu-right__inner--content" },
                        React.createElement("div", { className: "menu-right__header" },
                            React.createElement("div", { className: "menu-right__close", onClick: closeMenuRight },
                                React.createElement("img", { className: "menu-right__close-icon", src: pathToStatic + "images/icon_close.svg", alt: i18n("general.close") })),
                            React.createElement("div", { className: "title" }, i18n("rightMenu.title"))),
                        React.createElement("nav", { className: "navbar navbar-top" },
                            React.createElement("div", { role: "navigation", id: "block-rightmenu", className: "block block-menu navigation menu--right" }, renderRightMenuItems()))))),
            React.createElement("div", { className: "menu-right__shadow" + (isOpen == true ? " isOpenedShadow" : "") }))));
});
export default RightMenu;
